// src/api/ml.js
import http from "./http";
import { buildApiUrl } from "./client";

export function getMlRunFileUrl(runId, fileName) {
  return buildApiUrl(`/api/ml/runs/${encodeURIComponent(runId)}/files/${encodeURIComponent(fileName)}`);
}

export async function runMlModel() {
  return http("/api/ml/run", { method: "POST" });
}

export async function listMlRuns() {
  return http("/api/ml/runs", { method: "GET" });
}

export async function getMlRun(runId) {
  return http(`/api/ml/runs/${encodeURIComponent(runId)}`, {
    method: "GET",
  });
}

export async function listMlRunFiles(runId) {
  return http(`/api/ml/runs/${encodeURIComponent(runId)}/files`, {
    method: "GET",
  });
}

export async function getMlRunFileText(runId, fileName) {
  return http(
    `/api/ml/runs/${encodeURIComponent(runId)}/files/${encodeURIComponent(fileName)}`,
    { method: "GET", responseType: "text" }
  );
}

export async function getMlLog(runId, kind /* "train" | "predict" */) {
  return http(
    `/api/ml/runs/${encodeURIComponent(runId)}/logs/${encodeURIComponent(kind)}`,
    { method: "GET", responseType: "text" }
  );
}

export async function pinMlRun(runId, pinned) {
  return http(`/api/ml/runs/${encodeURIComponent(runId)}`, {
    method: "PATCH",
    body: JSON.stringify({ pinned: !!pinned }),
  });
}

export async function listRunIds() {
  return http("/api/ml/run-ids", { method: "GET" });
}

export async function getMlRunSummary(runId) {
  return http(`/api/ml/runs/${encodeURIComponent(runId)}/summary`, { method: "GET" });
}

export async function getMlRootCause(runId) {
  return http(`/api/ml/runs/${encodeURIComponent(runId)}/root-cause`, { method: "GET" });
}
